import EditHandleTypeEnum from "../enums/EditHandleTypeEnum";

// Maps a handle's kind to the i18n key for its hover tooltip text.
export function getEditHandleTooltipKey(handleType: EditHandleTypeEnum): string {
    switch (handleType) {
        case EditHandleTypeEnum.START_POINT: return 'ui.editHandle.tooltip.startPoint';
        case EditHandleTypeEnum.END_POINT: return 'ui.editHandle.tooltip.endPoint';
        case EditHandleTypeEnum.DIMENSION_OFFSET: return 'ui.editHandle.tooltip.dimensionOffset';
        case EditHandleTypeEnum.POLYGON_VERTEX: return 'ui.editHandle.tooltip.polygonVertex';
        case EditHandleTypeEnum.RECTANGLE_CORNER: return 'ui.editHandle.tooltip.rectangleCorner';
        case EditHandleTypeEnum.CIRCLE_RADIUS: return 'ui.editHandle.tooltip.circleRadius';
        case EditHandleTypeEnum.EXTRUSION_DEPTH: return 'ui.editHandle.tooltip.extrusionDepth';
    }
}
